import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/downloadSchedulerGroups', request, null, {responseType: 'arraybuffer'})
}

export {get}
